import {
  CartApprovalDisplay,
  CartCreatedOrReceived,
  CartDate,
  CartId,
  CartNotes,
  // CartPublic,
  CartTags,
  CartTitle,
  CartTotalPrice,
  CartTotalQty,
  CartVendor,
} from 'src/components';
import { useCurrentUser } from 'src/hooks';
import type { CartHistoryData } from 'src/types';

type Props = {
  cart: CartHistoryData;
};

export const CartsDisplayListItem = ({ cart }: Props) => {
  const { user } = useCurrentUser();

  const userSubTier = user?.subscription.tier;
  const userInOrg = userSubTier === 'organization';

  const currentApprovalDetail = cart.approvalDetails?.at(-1);
  const currentApprovalStatus = currentApprovalDetail?.status || null;

  const linkToReviewPage =
    userSubTier === 'organization' &&
    (user!.subscription.role === 'admin' ||
      user!.subscription.role === 'approver') &&
    (currentApprovalStatus === 'pending' ||
      currentApprovalStatus === 'rejected');

  return (
    <li
      key={cart.cart.id}
      className={`min-h-[82px] min-w-[768px] items-center justify-center border-b border-blueGray ${userInOrg ? 'min-[1380px]:min-h-[48px]' : 'lgXl:min-h-[48px]'} ${currentApprovalStatus === 'pending' ? 'bg-cloudGray' : ''}`}
    >
      <div className='grid-rows-auto mx-auto grid max-w-[1800px] grid-cols-12 items-center justify-center gap-x-2 px-6 py-2 lg:px-8'>
        <div
          className={`col-span-7 row-start-1 inline-flex flex-nowrap items-center justify-start gap-3 ${userInOrg ? 'min-[1380px]:col-span-3' : 'lgXl:col-span-3'}`}
        >
          <div className='max-w-[26px]'>
            <CartCreatedOrReceived created={cart.created} />
          </div>
          <div
            className={`min-w-[200px] max-w-[240px] xs:max-w-[280px] ${userInOrg ? 'min-[1380px]:max-w-[100%]' : 'lgXl:max-w-[100%]'}`}
          >
            <CartTitle
              cartId={cart.cart.id}
              cartTitle={cart.cart.title || ''}
              cartCreated={cart.created}
              forGetPage={false}
              cartVendorDisplayName={cart.vendorDisplayName || ''}
              linkToReviewPage={linkToReviewPage}
            />
          </div>
        </div>
        <div
          className={`col-span-5 row-start-1 flex flex-row flex-nowrap items-center justify-end gap-4 ${userInOrg ? 'min-[1380px]:col-span-2' : 'lgXl:col-span-2'}`}
        >
          <div className='min-w-[150px] text-right'>
            <CartTotalPrice totalPrice={cart.formattedPrice || 0} />
          </div>
          <div className='min-w-[80px] text-right'>
            <CartTotalQty
              totalQty={cart.cart.cartTotalQty || 0}
              cartId={cart.cart.id}
              linkToReviewPage={linkToReviewPage}
            />
          </div>
        </div>
        <div
          className={`col-span-12 row-start-2 inline-flex flex-nowrap items-start justify-start gap-x-4 font-secondary text-sm ${userInOrg ? 'min-[1380px]:col-span-7 min-[1380px]:col-start-4 min-[1380px]:row-start-1 min-[1380px]:items-center' : 'lgXl:col-span-7 lgXl:col-start-4 lgXl:row-start-1 lgXl:items-center'}`}
        >
          <div className='inline-flex min-h-[36px] flex-nowrap items-center justify-start gap-x-4'>
            <CartVendor
              cartVendor={cart.cart.vendor ? cart.cart.vendor : 'Unknown'}
              cartVendorDisplayName={
                cart.vendorDisplayName
                  ? cart.vendorDisplayName
                  : cart.cart.vendor
                    ? cart.cart.vendor
                    : 'Unknown'
              }
            />
            <CartId cartId={cart.cart.id} />
            <CartDate
              cartTimestamp={
                cart.cart.timestamp
                  ? cart.cart.timestamp
                  : cart.timestamp
                    ? cart.timestamp
                    : 0
              }
              forGetPage={false}
            />
            {/* <CartPublic
                      cartId={cart.cart.id}
                      cartListed={cart.listed || false}
                      forGetPage={false}
                      cartVendorDisplayName={cart.vendorDisplayName || ''}
                    /> */}
            <CartNotes
              cartId={cart.cart.id}
              cartNotes={cart.note || ''}
              forGetPage={false}
              cartVendorDisplayName={cart.vendorDisplayName || ''}
              approvalCart={'approvalDetails' in cart}
            />
          </div>
          <CartApprovalDisplay
            cartApprovalDetails={cart.approvalDetails || null}
            cartApprovalStatus={currentApprovalStatus}
            cartId={cart.cart.id}
            requestedByEmail={currentApprovalDetail?.requestedBy?.email || ''}
            includeLink={true}
            fromHistory={true}
            page='history'
          />
          <CartTags
            cartId={cart.cart.id}
            cartTags={cart.tags || []}
            forGetPage={false}
            cartVendorDisplayName={cart.vendorDisplayName || ''}
          />
        </div>
      </div>
    </li>
  );
};
